import { queryGraphQL } from 'common/util/query';
import { toQuery, nodeWithArgs, node } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

export const LOAD_STUDY_TEAM = 'LOAD_STUDY_TEAM';

export function loadStudyTeam(studyId, institutionId) {
    return (dispatch, setState) => {
        const query = nodeWithArgs('getStudyTeam', {
            studyId,
            institutionId,
        }, ['totalCount',
            node('studyTeamMember', [
                'id',
                'institutionId',
                'userId',
                'isClinicalStaff',
                'hasAdminRole',
                'studyUserType',
                'nameOfResearcher',
                'studyRoleId',
                node('studyRole', [
                    'id',
                    'name',
                    'institutionId',
                    'active',
                ]),
                'studyId',
                node('user', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
            ])
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve team for study'));
            } else {
                const studyTeam = results.data.getStudyTeam.studyTeamMember;

                dispatch({
                    type: LOAD_STUDY_TEAM,
                    payload: studyTeam,
                });
            }
        });
    };
}